import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { Api } from '../../api.service'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import { Selectors } from './selectors'
import { State } from './state'

// TODO: ideally, this should eventually be able to use the requests plugin to
// help deduplicate requests, track loading, etc.

/**
 * TODO:
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('ActionTestingPlugin')

  /** @see {@link Api} */
  public readonly api: Api = ngCore.inject(Api)

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
